import { useEffect, useState } from "react";
import Rating from "react-rating";
import heroBanner from "../../assets/images/page-title.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

import * as API from "../../api/api.js";
import PageLoading from "../../components/PageLoading.jsx";
import { reviewsData } from "../../data/reviews.js";
import ShellCard from "../../components/ShellCard.jsx";
import "./Reviews.css";

let records_per_page = 4;
let totalRecords = 0;
let filter = "latest";
import emptySymbol from "../../assets/images/star-empty-yellow.png";
import fullSymbol from "../../assets/images/star-full-yellow.png";
import quoteImg from "../../assets/images/quotation-1.png";

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [prevDisabled, setPrevDisabled] = useState(false);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [filterValue, setFilterValue] = useState("latest");
  const [avgReviews, setAvgReviews] = useState(reviewsData.average);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPagesState, setTotalPagesState] = useState(0);

  useEffect(() => {
    getPaginateData(1, filter);
  }, []);

  const prevPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      getPaginateData(newPage, filter);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPagesState) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      getPaginateData(newPage, filter);
    }
  };

  const checkPrevNextDisabled = (page, totalPages) => {
    if (page <= 1) {
      setPrevDisabled(true);
    } else {
      setPrevDisabled(false);
    }

    if (page >= totalPages) {
      setNextDisabled(true);
    } else {
      setNextDisabled(false);
    }
  };

  const getPaginateData = (page, filter) => {
    setLoading(true);

    setTimeout(() => {
      let filteredReviews = [...reviewsData.reviews];

      if (filter === "latest") {
        filteredReviews.sort(
          (a, b) => new Date(b.review_date) - new Date(a.review_date)
        );
      } else if (filter === "oldest") {
        filteredReviews.sort(
          (a, b) => new Date(a.review_date) - new Date(b.review_date)
        );
      } else if (filter === "highest") {
        filteredReviews.sort((a, b) => b.rating - a.rating);
      } else if (filter === "lowest") {
        filteredReviews.sort((a, b) => a.rating - b.rating);
      }

      const startIndex = (page - 1) * records_per_page;
      const endIndex = startIndex + records_per_page;
      const paginatedReviews = filteredReviews.slice(startIndex, endIndex);

      paginatedReviews.forEach((uData) => {
        uData.quoteImg = quoteImg;
        uData.emptySymbol = emptySymbol;
        uData.fullSymbol = fullSymbol;
      });

      const calculatedTotalPages = Math.ceil(
        filteredReviews.length / records_per_page
      );

      setReviews(paginatedReviews);
      setCurrentPage(page);
      setTotalPagesState(calculatedTotalPages);
      totalRecords = filteredReviews.length;
      setAvgReviews(reviewsData.average);
      checkPrevNextDisabled(page, calculatedTotalPages);
      setLoading(false);
    }, 300);
  };

  const handleChange = (e) => {
    setFilterValue(e.target.value);
    filter = e.target.value;
    setCurrentPage(1);
    getPaginateData(1, e.target.value);
  };

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">Customer Reviews</h1>
              <p className="banner-subheading">Metro Traffic School</p>
            </div>
          </div>
        </div>
      </section>

      <section className="container py-5">
        <div className="row">
          <div className="col-12">
            <ShellCard>
              <div className="row">
                <div className="col-12 col-sm-12 col-md-8 col-lg-7 col-xl-7 col-xxl-7 mb-md-0 mb-3 d-flex align-items-center">
                  <h5
                    className="small-heading d-flex flex-wrap flex-sm-nowrap align-items-center mb-0"
                    style={{ color: "#fff" }}
                  >
                    <span>Average rating :</span>
                    <Rating
                      initialRating={avgReviews}
                      readonly
                      fractions={2}
                      emptySymbol={<img src={emptySymbol} className="icon" />}
                      fullSymbol={
                        <img
                          src={fullSymbol}
                          className="icon"
                          style={{ maxWidth: "unset" }}
                        />
                      }
                      className="ms-2 ms-md-4"
                    />
                    <span className="ms-2" style={{ color: "var(--metro-yellow)" }}>
                      {totalRecords <= 10
                        ? totalRecords
                        : Math.floor(totalRecords / 10) * 10}{" "}
                      + Reviews{" "}
                    </span>
                  </h5>
                </div>
                <div className="col-12 col-sm-12 col-md-4 col-lg-5 col-xl-5 col-xxl-5 d-flex align-items-center justify-content-md-end justify-content-start">
                  <select
                    className="form-select form-select-lg fw-bold"
                    aria-label="Default select example"
                    value={filterValue}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#333",
                      color: "var(--metro-yellow)",
                      border: "2px solid var(--metro-yellow)",
                      fontSize: "16px",
                      paddingRight: "3rem",
                      minWidth: "250px",
                      width: "auto",
                    }}
                  >
                    <option
                      value={"latest"}
                      style={{ backgroundColor: "#333", color: "var(--metro-yellow)" }}
                    >
                      Newest to Oldest
                    </option>
                    <option
                      value={"oldest"}
                      style={{ backgroundColor: "#333", color: "var(--metro-yellow)" }}
                    >
                      Oldest to Newest
                    </option>
                    <option
                      value={"lowest"}
                      style={{ backgroundColor: "#333", color: "var(--metro-yellow)" }}
                    >
                      Lowest to Highest
                    </option>
                    <option
                      value={"highest"}
                      style={{ backgroundColor: "#333", color: "var(--metro-yellow)" }}
                    >
                      Highest to Lowest
                    </option>
                  </select>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xl-12 mb-3 mb-md-3 mt-3 mt-md-0">
                  <p className="pt-3" style={{ color: "#fff" }}>
                    Metro Traffic School is proud to provide customer service
                    via Live Chat, Phone and Email. We have some of the highest
                    customer service ratings in Florida. Here are some customer
                    reviews left by our students.
                  </p>
                </div>
                {!loading &&
                  reviews &&
                  reviews.map((rData, rIndex) => {
                    return (
                      <div
                        key={rIndex}
                        className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xl-6 mb-3 mb-md-3"
                      >
                        <div
                          className="review-inner-box rounded"
                          style={{
                            backgroundColor: "#333",
                            padding: "20px",
                            border: "1px solid var(--metro-yellow)",
                          }}
                        >
                          <div className="review-box d-flex justify-content-between align-items-center mb-md-3 mb-3">
                            <div className="review-star">
                              <Rating
                                initialRating={rData.rating}
                                readonly
                                fractions={2}
                                emptySymbol={
                                  <img
                                    src={rData.emptySymbol}
                                    className="icon"
                                  />
                                }
                                fullSymbol={
                                  <img
                                    src={rData.fullSymbol}
                                    className="icon"
                                    style={{ maxWidth: "unset" }}
                                  />
                                }
                              />
                            </div>
                            <div className="date">
                              <span style={{ color: "var(--metro-yellow)" }}>
                                {rData.review_date}
                              </span>
                            </div>
                          </div>
                          <h5
                            className="review-title mb-2"
                            style={{ color: "var(--metro-yellow)", fontWeight: "bold" }}
                          >
                            {rData.title}
                          </h5>
                          <span
                            className="review-content mb-3 mb-md-4 d-block"
                            style={{ color: "#fff", textAlign: "justify" }}
                          >
                            {rData.message}
                          </span>
                          <div className="total-review-box d-flex justify-content-between align-items-center">
                            <div className="review-name-role">
                              <h3
                                className="review-name mb-0"
                                style={{ color: "var(--metro-yellow)" }}
                              >
                                {rData.name}
                              </h3>
                              <span style={{ color: "#fff" }}>
                                {rData.role}
                              </span>
                            </div>
                            <div className="review-image d-flex flex-row justify-content-center align-items-center">
                              {rData.avatar_url ? (
                                <img src={rData.avatar_url} alt="" />
                              ) : (
                                <div
                                  className="d-flex justify-content-center align-items-center rounded-circle"
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    backgroundColor: "var(--metro-yellow)",
                                    color: "#111",
                                  }}
                                >
                                  <FontAwesomeIcon icon={faUser} size="lg" />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {!loading && reviews && totalPagesState > 1 && (
                  <nav aria-label="Page navigation example" className="my-3">
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ gap: "15px" }}
                    >
                      <button
                        type="button"
                        onClick={prevPage}
                        disabled={prevDisabled}
                        className="btn fw-bold text-dark metro-btn-primary text-decoration-none"
                        style={{ padding: "8px 12px" }}
                      >
                        <FontAwesomeIcon
                          icon={faChevronLeft}
                          className="me-2"
                        />
                        Previous
                      </button>

                      <button
                        type="button"
                        disabled
                        className="btn fw-bold rounded text-center"
                        style={{
                          backgroundColor: "#333",
                          border: "2px solid var(--metro-yellow)",
                          color: "var(--metro-yellow)",
                          minWidth: "100px",
                          cursor: "default",
                          padding: "8px 12px",
                        }}
                      >
                        Page {currentPage} of {totalPagesState}
                      </button>

                      <button
                        type="button"
                        onClick={nextPage}
                        disabled={nextDisabled}
                        className="btn fw-bold text-dark metro-btn-primary text-decoration-none"
                        style={{ padding: "8px 12px" }}
                      >
                        Next
                        <FontAwesomeIcon
                          icon={faChevronRight}
                          className="ms-2"
                        />
                      </button>
                    </div>
                  </nav>
                )}
                {loading && (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xl-12">
                    <PageLoading
                      color={"var(--metro-yellow)"}
                      classes={"justify-content-center"}
                    />
                  </div>
                )}
              </div>
            </ShellCard>
          </div>
        </div>
      </section>

      <section className="pb-5" style={{ backgroundColor: "#111" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 text-center">
              <p className="mb-4 text-white fs-5 lh-lg">
                Metro Traffic School is proud to provide customer service via
                Live Chat, Phone and Email. We have some of the highest customer
                service ratings in Florida.
              </p>
              <div
                className="p-4 rounded"
                style={{
                  backgroundColor: "#333",
                  border: "2px solid var(--metro-yellow)",
                }}
              >
                <h3 className="mb-3 fw-bold" style={{ color: "var(--metro-yellow)" }}>
                  Metro Traffic School
                </h3>
                <div className="d-flex justify-content-center align-items-center mb-2 gap-3 bottom-rating-container">
                  <Rating
                    initialRating={4.9}
                    readonly
                    fractions={10}
                    emptySymbol={<img src={emptySymbol} className="icon" />}
                    fullSymbol={
                      <img
                        src={fullSymbol}
                        className="icon"
                        style={{ maxWidth: "unset" }}
                      />
                    }
                  />
                  <span className="fs-4 fw-bold" style={{ color: "var(--metro-yellow)" }}>
                    4.9 out of 5
                  </span>
                </div>
                <p className="mb-0 text-white">
                  with worst rating 4, based on 60 user ratings out of 60
                  reviews.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Reviews;
